import path from '@/api/index'
import {
    axios,
    axiosFile
} from '@/utils/request'
import parsePageParams from '@/utils/page'

// 分页
export function queryList(data) {
    return axios({
        url: path.mobile + '/entrust',
        method: 'POST',
        data: data,
        params: parsePageParams(data)
    })
}

export function get (id) {
    return axios({
        url: path.mobile + '/entrust/id/' + id,
        method: 'GET'
    })
}
export function add (data) {
    return axios({
        url: path.mobile + '/entrust/add',
        method: 'PUT',
        data: data
    })
}

export function del (data) {
    return axios({
        url: path.mobile + '/entrust',
        method: 'DELETE',
        data: data
    })
}

export function complete (data) {
    return axios({
        url: path.mobile + '/entrust/complete',
        method: 'POST',
        data: data
    })
}

// 下载
export function exportPdf (id) {
    return axiosFile({
        url: path.mobile + '/entrust/export/' + id,
        method: 'GET',
    })
}
